// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kXDZs","main-image":"Header_main-image__BMZkr"};